import axios from 'axios'
import { getSavedState, saveState } from '../store-utils'

export const state = {
  cachedActivities: getSavedState('device.activities'),
  selectedActivity: null,
}

export const getters = {
  cachedActivities(state) {
    return state.cachedActivities
  },
  selectedActivity(state) {
    return state.selectedActivity
  },
}

export const mutations = {
  SET_CACHE(state, activities) {
    state.cachedActivities = activities
    saveState('device.activities', activities)
  },
  SET_SELECTED(state, activity) {
    state.selectedActivity = activity
  },
}

export const actions = {
  selectActivity({ commit, state, rootState }, { activity }) {
    commit('SET_SELECTED', activity)
  },

  fetchActivities({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedGroups the activity groups.
    const matchedActivities = state.cachedActivities
    if (!clearCache && matchedActivities) {
      return Promise.resolve(matchedActivities)
    }

    // 2. Fetch the activities from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/DeviceActivity/GetAll')
      .then((response) => {
        const activities = response.data.items
        commit('SET_CACHE', activities)
        return activities
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },

  updateActivity({ commit, dispatch, state, rootState }, { activity }) {
    return axios
      .put('/api/services/app/DeviceActivity/Update', activity)
      .then((response) => {
        dispatch('fetchActivities', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
